<template>
  <a-modal
    title="选择保险类型"
    :visible="visible"
    :destroyOnClose="true"
    width="525px"
    okText="确定"
    cancelText="取消"
    @ok="handleOk"
    @cancel="handleCancel">
    <a-spin :spinning="loading">
      <div>
        <div class="card" v-for="(item, index) in data" :key="index" @click="choice(item)">
          <div>
            <img class="conver" :src="item.conver"/>
          </div>
          <div class="content">
            <div class="row1">
              <p>{{ item.name }}</p>
              <span class="price">￥{{ item.amount }}/人</span>
            </div>
            <span class="des" :title="item.description">{{ item.description }}</span>
            <img class="select" v-show="selectedItem != null && selectedItem.id == item.id" :src="selectedImg"/>
            <div class="row3">
              <span @click.stop="showDetail(item)">《投保须知》</span>
            </div>
          </div>
        </div>
      </div>
    </a-spin>
  </a-modal>
</template>
<script>
export default {
  data () {
    return {
      loading: false,
      visible: false,
      selectedItem: null,
      selectedImg: require('@comm/assets/selected.png'),
      matchId: this.$route.query.matchId,
      data: []
    }
  },
  methods: {
    show () {
      this.queryInsuranceType()
    },
    handleOk () {
      if (this.selectedItem == null) {
        this.$message.error('请选择要购买的保险险种')
        return
      }
      this.$emit('insuranceTypeOk', this.selectedItem)
      this.handleCancel()
    },
    handleCancel () {
      this.visible = false
      this.selectedItem = null
    },
    queryInsuranceType () {
      this.loading = true
      this.$api.join.findMatchInsurance(this.matchId).then(res => {
        if (res.status === 0) {
          if (res.data.length === 0) {
            this.$message.error('组委会未设置保险方案！')
          } else if (res.data.length === 1) {
            this.$emit('insuranceTypeOk', res.data[0])
          } else {
            this.visible = true
            this.data = res.data
          }
        } else {
          this.$message.error(res.msg)
        }
      }).catch(error => {
        this.$message.error('获取保险信息失败' + error)
      }).finally(() => {
        this.loading = false
      })
    },
    choice (item) {
      if (this.selectedItem != null && this.selectedItem.id == item.id) {
        this.selectedItem = null
      } else {
        this.selectedItem = item
      }
    },
    showDetail (item) {
      window.open(item.detailUrl, 'detailUrl')
    }
  }
}
</script>
<style scoped>
  .card {
    width: 475px;
    background: white;
    border: 1px solid rgb(208, 208, 208);
    border-radius: 5px;
    /*padding: 10px;*/
    /*position: relative;*/
    margin-bottom: 10px;
    cursor: default;
    display: flex;
    justify-content: flex-start;
    flex-wrap: nowrap;
  }
  .row1 {
    display: flex;
    justify-content: space-between
  }
  .row3 {
    display: flex;
    justify-content: flex-end;
  }
  .row3 span{
    color: #1890ff;
    cursor: pointer;
  }
  .card .conver {
    width: 135px;
    height: 107px;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
  }
  .card .content {
    padding: 10px;
    position: relative;
    width: 340px;
  }
  .card p {
    font-size: 18px;
    font-weight: bold;
    cursor: pointer;
  }
  .des{
    color: #939393;
    width: 330px;
    cursor: default;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
    word-break: break-all;
  }
  .price {
    color: #db9008;
    font-size: 21px;
  }
  .card .select {
    width: 50px;
    position: absolute;
    top: 0;
    left: 289px;
    cursor: default;
    opacity: 0.8;
  }
</style>



// WEBPACK FOOTER //
// src/comm/components/join/pay/InsuranceType.vue